// extracted by mini-css-extract-plugin
export default {"menuBlock":"zE-z","title":"AE-z","nav":"BE-z","flexCell":"CE-z","facetLink":"DE-z"};